export enum ConfigKey {
  MaintenanceDate = 'MaintenanceDate',
  MaintenanceTime = 'MaintenanceTime',
  MaxAdultAge = 'MaxAdultAge',
  MaxAdultCount = 'MaxAdultCount',
  MaxChildAge = 'MaxChildAge',
  MaxChildAgeQuantifier = 'MaxChildAgeQuantifier',
  MaxChildCount = 'MaxChildCount',
  MaxChildStudentAge = 'MaxChildStudentAge',
  MaxDomesticDay = 'MaxDomesticDay',
  MaxFamilyAdultCount = 'MaxFamilyAdultCount',
  MaxFamilyChildCount = 'MaxFamilyChildCount',
  MaxInternationalDay = 'MaxInternationalDay',
  MaxProposerAge = 'MaxProposerAge',
  MaxSeniorAge = 'MaxSeniorAge',
  MaxSeniorCount = 'MaxSeniorCount',
  MaxStartDateDayCount = 'MaxStartDateDayCount',
  MethodServiceName = 'MethodServiceName',
  MinAdultAge = 'MinAdultAge',
  MinChildAge = 'MinChildAge',
  MinChildAgeQuantifier = 'MinChildAgeQuantifier',
  MinChildStudentAge = 'MinChildStudentAge',
  MinFamilyAdultCount = 'MinFamilyAdultCount',
  MinFamilyChildCount = 'MinFamilyChildCount',
  MinProposerAge = 'MinProposerAge',
  MinSeniorAge = 'MinSeniorAge',
}
